const Jumbotron = () => {
    return ( 
        <div className="jumbotron jumbotron-fluid">
            <div className="container">
                <h1 className="display-4">Employee Directory</h1>
            </div>
        </div>
     );
}
 
export default Jumbotron;